function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M25.5 9.014h-6V12h6V9.014zm3 0V14.5a.5.5 0 0 1-.5.5H17a.5.5 0 0 1-.5-.5V9.014h-5.99a1.5 1.5 0 0 0-1.5 1.5v18.017a1.5 1.5 0 0 0 1.5 1.5H22.5v3H10.51a4.5 4.5 0 0 1-4.5-4.5V10.514a4.5 4.5 0 0 1 4.5-4.5h23.965a4.5 4.5 0 0 1 4.5 4.5v13.533h-3V10.514a1.5 1.5 0 0 0-1.5-1.5H28.5zM13.5 27a1.5 1.5 0 0 1 0-3h3a1.5 1.5 0 0 1 0 3h-3zM30 32.625c0-1.036.672-1.875 1.5-1.875s1.5.84 1.5 1.875v2.265c0 1.036-.672 1.86-1.5 1.86s-1.5-.824-1.5-1.86v-2.265zm1.5-3.375a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 9.75a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zm0 3C25.701 42 21 37.299 21 31.5S25.701 21 31.5 21 42 25.701 42 31.5 37.299 42 31.5 42z"
});

var SvgInfoGeneral = function SvgInfoGeneral(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgInfoGeneral;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/info-general.svg
// module id = 120
// module chunks = 0 1